import { LineChart } from "lucide-react";
import React, { useState } from "react";
import { ActionIcon, Drawer } from "@mantine/core";
import AnnouncementStatsCard from "../components/AnnouncementStatsCard";

type ViewAnnouncementStatsActionIconProps = {
  id: number;
};

const ViewAnnouncementStatsActionIcon: React.FC<
  ViewAnnouncementStatsActionIconProps
> = ({ id }) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        size="xl"
        onClose={() => setOpened(false)}
        title="Engagement Summary"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div style={{ padding: "25px", height: "80%", overflow: "auto" }}>
          <AnnouncementStatsCard announcementId={id} />
        </div>
      </Drawer>

      <ActionIcon onClick={() => setOpened(true)}>
        <LineChart size={18} />
      </ActionIcon>
    </>
  );
};

export default ViewAnnouncementStatsActionIcon;
